import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  applicationId: attr(String),
  applicationName: attr(String),
  name: attr(String),
  clientOu: attr(String)
});